<!--
  @component
  
  Handles offer's view and hit statistics.
-->
<script lang="ts" context="module">

  type Action = 'hit' | 'view';

  type ActionStack = {
    ids: number[];
    timeout_id: NodeJS.Timeout | undefined;
  }

  type ActionStacks = {
    hit: ActionStack;
    view: ActionStack;
  };

  const action_stack: ActionStacks = {
    hit: { ids: [], timeout_id: undefined },
    view: { ids: [], timeout_id: undefined },
  };

  function sendStat(action: Action, id: number) {
    const stack = action_stack[action];
    clearTimeout(stack.timeout_id);
    stack.ids.push(id);

    stack.timeout_id = setTimeout(() => {
      // Empty
      const ids = stack.ids.splice(0, stack.ids.length);
      try {
        fetch(`/api/ostats.json?action=${action}&ids=${ids.join()}`, { method: 'POST' });
      } catch (error) {
        console.error(error);
      }
    }, 200);
  }

  export function hit (id: number) {
    sendStat('hit', id);
  }

</script>

<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { inview } from 'svelte-inview';

  export let id = 0;

  const options = {
    threshold: 1,
    unobserveOnEnter: true
  };

  const dispatch = createEventDispatcher();

  export function view (event: CustomEvent) {
    const { inView } = event.detail;
    if (inView) {
      sendStat('view', id);
    }
  }

  function interaction () {
    dispatch("focusOffer", id);
    hit(id);
  }

</script>


<div
  use:inview={options}
  on:inview_change={view}
  on:click={interaction}
  on:keydown={interaction}
>
  <slot />
</div>
